<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="版本名称" prop="versionName">
                <a-input v-model="queryParam.versionName" placeholder="请输入版本名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="平台" prop="platform">
                <api-select
                  v-model="queryParam.platform"
                  placeholder="请选择平台"
                  :option="[
                    { id: 1, name: '安卓' },
                    { id: 2, name: 'IOS' },
                  ]" />
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="客户端类型" prop="client">
                  <api-select
                    v-model="queryParam.client"
                    placeholder="请选择客户端类型"
                    :option="[
                      { id: 1, name: '用户端' },
                      { id: 2, name: '商家端' },
                    ]" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否强制更新" prop="musted">
                  <api-select
                    v-model="queryParam.musted"
                    placeholder="请选择强制更新"
                    :option="[
                      { id: 0, name: '不强制' },
                      { id: 1, name: '强制' },
                    ]" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否展示弹窗" prop="isShow">
                  <api-select
                    v-model="queryParam.isShow"
                    placeholder="是否展示弹窗"
                    :option="[
                      { id: 0, name: '否' },
                      { id: 1, name: '是' },
                    ]" />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['app:version:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['app:version:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['app:version:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['app:version:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['app:version:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['app:version:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['app:version:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['app:version:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
        <span slot="download" slot-scope="text, record">
          <a :href="text">{{ text }}</a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listVersion, delVersion } from '@/api/app/version'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import ApiSelect from '@/views/config/badge/modules/ApiSelect.vue'

export default {
  name: 'Version',
  components: {
    CreateForm, ApiSelect
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        versionName: null,
        content: null,
        musted: null,
        isShow: null,
        platform: null,
        client: null,
        url: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
      {
          title: '版本名称',
          dataIndex: 'versionName',
          ellipsis: true,
          align: 'center',
          width: 80
        },
        {
          title: '版本号',
          dataIndex: 'versionCode',
          ellipsis: true,
          align: 'center',
          width: 80
        },
        {
          title: '升级内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '强制更新',
          dataIndex: 'musted',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { '1': '强制', '0': '不强制' }[text]
          },
          width: 80
        },
        {
          title: '展示弹窗',
          dataIndex: 'isShow',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { '1': '是', '0': '否' }[text]
          },
          width: 80
        },
        {
          title: '平台',
          dataIndex: 'platform',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { '1': '安卓', '2': 'IOS' }[text]
          },
          width: 50
        },
        {
          title: '客户端',
          dataIndex: 'client',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { '1': '用户端', '2': '商家端' }[text]
          },
          width: 80
        },
        {
          title: '下载地址',
          dataIndex: 'url',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'download' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询app版本列表 */
    getList() {
      this.loading = true
      listVersion(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        versionName: undefined,
        content: undefined,
        musted: undefined,
        isShow: undefined,
        platform: undefined,
        client: undefined,
        url: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          return delVersion(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() { }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('app/version/export', {
            ...that.queryParam
          }, `version_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
